import React, { Suspense, lazy } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Loading } from '@com-components/'
import Home from '../pages/home'

const Login = lazy(() => import('../pages/login'))
const ErrorResult = lazy(() => import('../pages/error-result'))

const Routes = () => (
  <Suspense fallback={<Loading />}>
    <Switch>
      <Route
        path="/"
        render={({ location, history, match }) => {
          const { pathname } = location
          if (pathname === '/login') {
            return <Login location={location} history={history} match={match} />
          }
          if (pathname === '/error') {
            return <ErrorResult location={location} history={history} match={match} />
          }
          return <Home location={location} history={history} match={match} />
        }}
      />
    </Switch>
  </Suspense>
)

export default Routes
